module.exports = __webpack_public_path__ + "assets/img/baoming.19fc8847.png";